import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import PaymentForm from '../../../../../PaymentForm';
import { format } from '../../../../../utils';
import { useTheme } from '../../../../../theme';
import { PAYMENT_KEY_TO_TYPE_MAP } from '../../../../../Payment/Payment';
import { useRenderers } from '../../../../../renderProps';
import SimpleLoader from '../../../../../SimpleLoader';
import { useCompletePayment } from '../../../../../PaymentForm/components/hooks';
import Notification from '../../../../../BaseComponents/Notification';
const Payment = ({ className, exchangeOrder, goToOrder, successPayment, failedPayment, paymentMethods }) => {
    const priceParts = React.useMemo(() => {
        return {
            total: exchangeOrder.prices.priceToPay,
            charge: exchangeOrder.prices.agencyChargesForExare
        };
    }, [exchangeOrder.prices]);
    const { t } = useTranslation('Exchange');
    const theme = useTheme('Exchange').Payment;
    const { completePayment, completePaymentLoading } = useCompletePayment({
        orderId: exchangeOrder.id,
        onSuccess: successPayment,
        onFail: failedPayment
    });
    const timelimitDate = new Date(Date.parse(exchangeOrder.timelimit));
    const paymentPage = React.useMemo(() => {
        const existsGateways = paymentMethods
            ? Object.keys(paymentMethods).filter(key => paymentMethods[key] !== null && PAYMENT_KEY_TO_TYPE_MAP.has(key))
            : [];
        if (existsGateways.length === 1) {
            return {
                type: PAYMENT_KEY_TO_TYPE_MAP.get(existsGateways[0]),
                content: null,
                title: ''
            };
        }
        else {
            return null;
        }
    }, [paymentMethods]);
    const { ExchangePaymentForm: ExchangePaymentFormOverride = PaymentForm } = useRenderers();
    return (React.createElement("div", { className: cn(className, theme.container) },
        completePaymentLoading && React.createElement(SimpleLoader, null),
        React.createElement(Notification, { className: theme.timelimit, type: 'context', status: 'error', text: t('Order must be paid by {{time}} on {{date}}', {
                time: format(timelimitDate, 'HH:mm'),
                date: format(timelimitDate, 'd MMMM yyyy')
            }) }),
        React.createElement(ExchangePaymentFormOverride, Object.assign({}, paymentMethods, { priceToPay: priceParts, onSuccess: successPayment, onFail: failedPayment, paymentPage: paymentPage, isPaymentAvailable: !!paymentMethods, onBackToOrder: goToOrder, onPaymentMethodSelected: () => null, onCompletePayment: completePayment }))));
};
export default Payment;
